export default __webpack_public_path__ + "static/media/icon-ci-reverso.40b6952a.svg";